import { Close } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import "./style.css";

export const ScreenSizeWarning = () => {
    const [open, setOpen] = useState(true);

    if (!open) {
        return null;
    }
    return (
        <div className="screen-size-warning-box">
          <div
            className="close-button"
            onClick={() => setOpen(false)}
          >
            <Tooltip title="Fermer" placement="top">
              <div>
                <Close style={{ color: "white", fontSize: "24px" }} />
              </div>
            </Tooltip>
          </div>

          <div className="screen-size-warning">
            {/* <img
              className="screen-size-warning-icon"
              src="/screensize_warning.svg"
              alt=""
            /> */}
            <svg className="screen-size-warning-icon" viewBox="0 0 266 202" fill="none" xmlns="http://www.w3.org/2000/svg" version="1.1">
              <g clipPath="url(#clip0_221_3)">
              <path d="M11.4868 201.99C23.959 201.99 36.4311 201.99 48.9033 201.99H256.616C262.523 201.071 266.434 196.491 265.821 190.651C265.632 188.854 264.882 187.042 264.065 185.393C258.02 173.181 251.858 161.03 245.844 148.803C245.099 147.287 244.675 145.444 244.675 143.754C244.609 103.193 244.639 62.6314 244.614 22.0701C244.614 19.8544 244.328 17.7408 243.797 15.7651C241.336 6.17228 233.3 0.0102242 222.395 0.0102242C162.756 -0.00509161 103.121 1.36503e-05 43.4815 0.0153294C41.8989 0.0153294 40.2856 0.045961 38.7387 0.342066C28.1861 2.37396 21.2736 10.8742 21.2634 21.9016C21.2379 62.4629 21.2634 103.024 21.2021 143.58C21.2021 145.275 20.7784 147.113 20.033 148.63C14.019 160.857 7.85698 173.007 1.81235 185.219C0.995503 186.868 0.250135 188.68 0.0561346 190.477C-0.633076 197.022 4.36498 201.985 11.4817 201.99H11.4868ZM42.6953 72.6581C42.7208 72.4948 42.7361 72.3263 42.7361 72.1578V21.6157H223.151V71.9791C223.151 72.1476 223.166 72.3161 223.192 72.4794V138.169H220.154V137.99H42.6953V72.6581Z" fill="currentColor"/>
              </g>
              <path d="M126.05 91.282L124.342 44.65H140.522L138.814 91.282H126.05ZM132.482 115.503C129.735 115.503 127.491 114.698 125.749 113.09C124.074 111.415 123.236 109.405 123.236 107.06C123.236 104.648 124.074 102.638 125.749 101.03C127.491 99.3555 129.735 98.518 132.482 98.518C135.162 98.518 137.34 99.3555 139.015 101.03C140.69 102.638 141.527 104.648 141.527 107.06C141.527 109.405 140.69 111.415 139.015 113.09C137.34 114.698 135.162 115.503 132.482 115.503Z" fill="currentColor"/>
              <defs>
              <clipPath id="clip0_221_3">
              <rect width="265.882" height="202" fill="currentColor"/>
              </clipPath>
              </defs>
              </svg>
            <span>Attention, votre résolution d'écran n'est pas optimale pour garantir la meilleure expérience utilisateur. Nous recommandons une résolution plus proche du 16:9.</span>
          </div>
        </div>
    );
}